import { render, staticRenderFns } from "./ClipLoader.vue?vue&type=template&id=44ebc356&"
import script from "./ClipLoader.vue?vue&type=script&lang=js&"
export * from "./ClipLoader.vue?vue&type=script&lang=js&"
import style0 from "./ClipLoader.vue?vue&type=style&index=0&id=44ebc356&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports